import * as React from 'react';
import { ExcelS3UploadInterfaceProps, ExcelS3UploadModelType } from './ExcelS3Upload.types';
import { Spin, Icon, Upload } from 'antd';
import CSVIcon from '../icons/CSVIcon';
import { tokens } from 'src/design-system';

export const ExcelS3UploadHtml = ({ model }: { model: ExcelS3UploadModelType }) => {
  const {
    headerText,
    fileType,
    customMessage,
    sampleLinkInfoText,
    sampleLink,
    classes,
    isMultiple,
    accept,
    showFileIcon,
    disableSampleLink,
    isLoading,
    fileList,
    isUploading,
    attachmentUploadMap,
    handleFileChange,
    handelRemoveFile,
    handleDownloadFile,
    handleCustomRequest,
    getFileList,
    required,
    isDownloading,
  } = model;

  const renderFileTypeIcon = () => {
    if (fileType === 'excel') {
      return <Icon type="file-excel" style={{ fontSize: '4.3em', color: tokens.colors.textTertiary }} />;
    } else if (fileType === 'any') {
      return <Icon type="file" style={{ fontSize: '4.3em', color: tokens.colors.textTertiary }} />;
    }
    return <CSVIcon width="1.3em" height="1.3em"></CSVIcon>;
  };
  return (
    <div className={classes.uploadFileContainer}>
      <Upload.Dragger
        customRequest={handleCustomRequest}
        style={{ padding: '16px' }}
        name="file"
        accept={accept}
        multiple={isMultiple}
        fileList={getFileList()}
        onChange={handleFileChange}
        onRemove={handelRemoveFile}
        showUploadList={{ showRemoveIcon: true, showDownloadIcon: false }}
      >
        <p style={{ marginBottom: 24, fontSize: '14px' }} className="ant-upload-hint">
          <strong>
            <Icon type="upload" /> {headerText || 'Upload a csv file to upload multiple shipments.'}{' '}
            {required ? <span style={{ color: tokens.colors.error }}>*</span> : ''}
          </strong>
        </p>
        {showFileIcon && <p className="ant-upload-drag-icon">{renderFileTypeIcon()}</p>}
        <p style={{ color: tokens.colors.textSecondary, marginBottom: 24 }} className="ant-upload-text">
          <b>
            Drag and drop to upload or <span style={{ color: tokens.colors.primary }}>Browse</span> to choose
            file
          </b>
        </p>
      </Upload.Dragger>
      {customMessage ? (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
          {customMessage}
        </div>
      ) : (
        <div
          style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}
          className={disableSampleLink ? classes.disableSampleText : ''}
        >
          {sampleLink && !disableSampleLink ? (
            <a href={sampleLink} target={'_blank'}>
              {sampleLinkInfoText || 'Download a sample file'}
            </a>
          ) : (
            <a
              onClick={() =>
                disableSampleLink || isLoading || isUploading || isDownloading
                  ? null
                  : handleDownloadFile()
              }
            >
              {isDownloading ? 'Downloading in progress' : (sampleLinkInfoText || 'Download sample file')}
            </a>
          )}
          {isLoading || isUploading || isDownloading ? (
            <Spin
              indicator={
                <Icon type="loading" style={{ fontSize: '20px', marginLeft: '10px' }} spin />
              }
            />
          ) : null}
        </div>
      )}
    </div>
  );
};
